module.exports = __webpack_public_path__ + "img/wendang.992fd9d4.png";